import React from 'react';
import CurrencyDropdown from 'src/containers/CurrencyDropdown';
import { formatMoneyWithCurrency } from 'src/utils/formatter';
import '../../../../configuracion/components/CurrencyChangeRow.scss';

const CLPTransactionExchangeForm = ({
  formData,
  handleLocalAmountChange,
  handleInvoiceCurrencyChange,
  handleInvoiceExchangeRateChange,
  maxLocalAmount,
  disabled = false,
  disableExchangeRate = false,
  exchangeRateDate = null
}) => {
  // Calculate Monto Moneda Original (localAmount / exchangeRate, max 2 decimals)
  const montoMonedaOriginal = formData.invoiceExchangeRate && formData.localAmount
    ? parseFloat((parseFloat(formData.localAmount) / parseFloat(formData.invoiceExchangeRate)).toFixed(2))
    : 0;

  return (
    <>
      {/* MONTO LOCAL input row */}
      <div className="currency-change-field" style={{ marginBottom: '16px' }}>
        <label className="currency-change-label" htmlFor="clp-transaction-local-amount">
          MONTO LOCAL
        </label>
        <input
          id="clp-transaction-local-amount"
          type="number"
          step="0.01"
          min="0"
          max={maxLocalAmount || 0}
          value={formData.localAmount || ""}
          onChange={handleLocalAmountChange}
          placeholder="0.00"
          inputMode="decimal"
          className="currency-change-input"
        />
        {maxLocalAmount > 0 && (
          <div style={{ 
            fontSize: '11px', 
            color: '#6B7280', 
            marginTop: '4px',
            fontStyle: 'italic'
          }}>
            El monto máximo a conciliar es {formatMoneyWithCurrency(maxLocalAmount, 'CLP')}
          </div>
        )}
      </div>

      {/* Currency, Exchange Rate, and Monto Moneda Original row */}
      <div 
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}
      >
        <div className="currency-change-field">
          <label className="currency-change-label" htmlFor="clp-transaction-currency">MONEDA</label>
          <CurrencyDropdown
            id="clp-transaction-currency"
            placeholder="Seleccione moneda"
            value={formData.invoiceCurrency || ''}
            onChange={handleInvoiceCurrencyChange}
            className="w-100"
            disabled={disabled}
          />
        </div>
        <div className="currency-change-field">
          <label className="currency-change-label" htmlFor="clp-transaction-exchange-rate">
            TIPO DE CAMBIO{exchangeRateDate ? ` (Fecha: ${exchangeRateDate})` : ''}
          </label>
          <input
            id="clp-transaction-exchange-rate"
            type="number"
            step="0.01"
            min="0"
            value={formData.invoiceExchangeRate || ""}
            onChange={handleInvoiceExchangeRateChange}
            placeholder="0.00"
            inputMode="decimal"
            disabled={disableExchangeRate}
            readOnly={disableExchangeRate}
            className={disableExchangeRate ? "currency-change-input currency-change-input-disabled" : "currency-change-input"}
          />
        </div>
        <div className="currency-change-field">
          <label className="currency-change-label" htmlFor="clp-transaction-original-amount">
            MONTO MONEDA ORIGINAL ({formData.invoiceCurrency || 'USD'})
          </label>
          <input
            id="clp-transaction-original-amount"
            type="text"
            value={montoMonedaOriginal.toFixed(2)}
            disabled
            readOnly
            placeholder="0.00"
            className="currency-change-input currency-change-input-disabled"
          />
        </div>
      </div>
    </>
  );
};

export default CLPTransactionExchangeForm;

